import { FilterStringOptions, NUMBER_OPERATION_OPTIONS } from '@dbl/core/filter';
export const MAX_FILTERS = 5;
export const DEFAULT_NAME_EN = 'All Users';
export const DEFAULT_NAME_CN = '全部用户';
export const DEFAULT_NAME = DEFAULT_NAME_EN;
export const DATALAB_COMPARE_USER_FILTERS = 'DATALAB_COMPARE_USER_FILTERS';
// 操作符选项
export const OPERATOR_OPTIONS: { [ket: string]: any[]; } = {
  default: [],
  string: [
    ...FilterStringOptions,
    {
      value: 'notNull',
      text: '有值',
      text_en: 'Non-null Values',
    },
    {
      value: 'null',
      text: '空值',
      text_en: 'Null Values',
    }
  ],
  number: NUMBER_OPERATION_OPTIONS,
  date: [],
};